import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import SearchInput from "../../components/SearchInput";
import { authFetch } from "../../utils/api";
import "../../styles/admin/aseguradoras.css"; 

const TIPO_AGENCIA = "Agente Aduanal";

export default function AgenteAduanal() {
  const [q, setQ] = useState("");
  const [agencias, setAgencias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError(null);

    authFetch(`/api/Agencia/tipo/${TIPO_AGENCIA}`) 
      .then(res => {
        if (!res.ok) {
          throw new Error(`No se pudieron cargar las agencias (tipo: ${TIPO_AGENCIA}).`);
        }
        return res.json();
      })
      .then(data => {
        setAgencias(data);
      })
      .catch(err => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []); 

  const rows = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return agencias; 
    return agencias.filter(r =>
      [r.nombre, r.telefono, r.correoElectronico].some(v => String(v).toLowerCase().includes(t))
    );
  }, [q, agencias]); 

  const handleAgregar = () => {
    navigate('/admin/agenteAduanal/agregar');
  };

  const handleEditar = (agencia) => {
    navigate(`/admin/agenteAduanal/editar/${agencia.id}`);
  };

  const handleDelete = async (agencia) => {
    if (!window.confirm(`¿Estás seguro de eliminar a ${agencia.nombre}?`)) {
      return;
    }

    try {
      const response = await authFetch(`/api/Agencia/${agencia.id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Error al eliminar la agencia.');
      }
      
      setAgencias(prevAgencias => 
        prevAgencias.filter(a => a.id !== agencia.id)
      );

    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <main className="aseg-main">
      <header className="aseg-header">
        <h1 className="aseg-title">Agentes Aduanales</h1>
        <button 
          type="button" 
          className="aseg-btn" 
          onClick={handleAgregar}
        >
          Agregar Agente
        </button>
      </header>

      <SearchInput
        placeholder="Buscar agente..."
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />

      <section className="aseg-card">
        
        {loading && <div className="aseg-loading">Cargando...</div>}
        {error && <div className="aseg-error">Error: {error}</div>}

        {!loading && !error && (
          <div className="aseg-table-wrapper">
            <table className="aseg-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Correo</th>
                  <th>Dirección</th>
                  <th className="col-acciones">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map(r => (
                    <tr key={r.id}>
                      <td>{r.nombre}</td>
                      <td>{r.telefono}</td>
                      <td className="td-email">{r.correoElectronico}</td>
                      <td>{r.direccion}</td>
                      <td className="td-acciones">
                        <button 
                          type="button" 
                          className="aseg-link" 
                          onClick={() => handleEditar(r)}
                        >
                          Editar
                        </button>
                        <button 
                          type="button" 
                          className="aseg-link aseg-link-danger"
                          onClick={() => handleDelete(r)}
                        >
                          Borrar
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="aseg-empty">
                      No se encontraron agentes aduanales.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </main>
  );
}